import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden"
}
const _hoisted_2 = { class: "relative flex flex-col items-center gap-8 px-6 text-center" }
const _hoisted_3 = { class: "relative flex h-24 w-24 items-center justify-center" }
const _hoisted_4 = { class: "flex flex-col gap-3" }
const _hoisted_5 = { class: "text-2xl font-bold tracking-tight text-white md:text-3xl" }
const _hoisted_6 = { class: "max-w-md text-base text-slate-300/90 leading-relaxed" }
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col gap-3 items-center justify-center w-full h-full"
}
const _hoisted_8 = { class: "rounded-md bg-red-50 p-4 w-full" }
const _hoisted_9 = { class: "flex flex-col items-start gap-2 md:flex-row md:items-center" }
const _hoisted_10 = { class: "flex items-start gap-2" }
const _hoisted_11 = { class: "flex flex-col md:flex-row items-start gap-1" }
const _hoisted_12 = { class: "text-sm font-medium text-red-700" }
const _hoisted_13 = {
  key: 2,
  class: "grid grid-cols-12 md:gap-10"
}
const _hoisted_14 = {
  key: 0,
  class: "col-span-12 md:pb-12 flex flex-col items-center justify-center gap-8"
}
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = { class: "absolute -left-4 flex h-[120px] w-[120px] items-center justify-center rounded-full border border-theme-gray-7" }
const _hoisted_17 = { class: "flex flex-col items-center gap-3" }
const _hoisted_18 = {
  key: 0,
  class: "rounded-full border border-slate-300/70 bg-white px-4 py-1 text-sm font-semibold text-slate-600"
}
const _hoisted_19 = { class: "w-full" }
const _hoisted_20 = { class: "mx-auto max-w-4xl rounded-2xl border border-green-200 bg-green-50 px-6 py-6 text-center" }
const _hoisted_21 = { class: "text-lg md:text-2xl font-semibold leading-relaxed text-green-800" }
const _hoisted_22 = {
  key: 1,
  class: "col-span-12 md:pb-12 flex flex-col items-center justify-center gap-6"
}
const _hoisted_23 = { class: "relative" }
const _hoisted_24 = { class: "flex items-center justify-center absolute -left-3 w-[100px] h-[100px] rounded-full border border-theme-gray-7" }
const _hoisted_25 = { class: "text-center flex flex-col gap-1 md:w-[80%]" }
const _hoisted_26 = { class: "rounded-md bg-yellow-50 p-4" }
const _hoisted_27 = { class: "flex flex-col items-start gap-2 md:flex-row md:items-center" }
const _hoisted_28 = { class: "flex items-start gap-2" }
const _hoisted_29 = { class: "flex flex-col md:flex-row items-start gap-1" }

import { ref, computed, onMounted } from 'vue'
import LoaderIcon from '@/components/LoaderIcon.vue'
import {
  handleApiError,
  clearSessionData,
  getBookingNumber,
  getPaymentSession,
  getPaymentTransaction,
  getPaymentCode,
  isLoggedIn,
  getDealId,
  getPaymentWallet,
} from '@/utils/common'
import Payment from '@/composables/Payment'
import BookingService from '@/services/booking-service'
import { useRouter, useRoute } from 'vue-router'
import CarService from '@/services/car-service'
import Loader from '@/widgets/Loader.vue'
import BookingVoucher from '@/pages/BookingVoucher.vue'
import Deal from '@/composables/Deal'


export default /*@__PURE__*/_defineComponent({
  __name: 'Finish',
  props: ['currentStep'],
  setup(__props) {

const props = __props

const isLoading = ref<boolean>(true)
const hasError  = ref<boolean>(false)

const booking: string | null     = getBookingNumber()
const transaction: string | null = getPaymentTransaction()
const session: string | null     = getPaymentSession()
const cvc: string | null         = getPaymentCode()
const paymentWallet: string | null = getPaymentWallet()

const isPaying = computed(() => {
  return !!(session && transaction)
})

const { authorizePayment, verifyPaymentStatus } = Payment()
const payload    = ref<any>(null)
const responsee  = ref<any>(null)
const { finalizeeBooking, readBooking } = BookingService()

const feed     = ref<any>()
const feedType = ref<'success' | 'error'>()

const router = useRouter()
const route = useRoute()
const { retrieveUserSelectedCar } = CarService()

const bookingNumber = ref<string>()
const dealId        = ref<string>()

const message      = ref<string>('Booking has been complete and payment has been recieved')
const errorMessage = ref<string>('')

const authUser = isLoggedIn()
const isAgencyOrCorporate = authUser && (authUser.user.type === 'agent' || authUser.user.type === 'corporate')

const handleGoBack = () => {
  if (isAgencyOrCorporate) {
    router.push({ name: 'AccountDashboard' })
  } else {
    router.push({ name: 'Home' })
  }
}

const { createDeal, updateDeal, createContact } = Deal()

onMounted(async () => {
  bookingNumber.value = getBookingNumber() as string
  dealId.value        = getDealId() as string

  if (!bookingNumber.value) {
    router.push({ name: 'Home' })
    return
  }

  const carResponse: any = retrieveUserSelectedCar()
  const isSuccessHint = route.query.status === 'success'

  // Fetch booking details to verify if it is a quote request
  const currentBooking = await readBooking(bookingNumber.value as string)
  console.log('--- DEBUG FINISH.VUE ---')
  console.log('bookingNumber:', bookingNumber.value)
  console.log('currentBooking success:', currentBooking.success)
  console.log('currentBooking data structure:', currentBooking.data)
  const isQuoteRequest = currentBooking.success && currentBooking.data?.data && 
    (currentBooking.data.data.status === 'need_confirmation' || currentBooking.data.data.status === 'incomplete' || currentBooking.data.data.status === 'unconfirmed')
  console.log('isQuoteRequest evaluated:', isQuoteRequest)
  console.log('------------------------')

  // 1. “Lead” / Quote Request flow (no price or need confirmation status from database)
  if ((carResponse && (carResponse.price == null || carResponse.price === 0)) || isQuoteRequest) {
    feedType.value = 'success'
    const finalResponse = await finalizeeBooking(bookingNumber.value, feedType.value, {}, true)
    isLoading.value = false

    if (finalResponse.success) {
      await upsertDeal()
      message.value = 'Your request has been created. You will be contacted by our representative shortly.'
      clearSessionData()
    } else {
      hasError.value = true
    }
    return
  }

  // 2. Active Server-to-Server Verification (Poll for payment status)
  let attempts = 0
  const maxAttempts = 4 // 4 attempts * 4 seconds = 16 seconds
  
  if (isSuccessHint) {
     message.value = 'Payment received! We are just finalizing your booking, please wait...'
  }

  const checkPaymentStatus = async () : Promise<boolean> => {
    // Actively ask Credimax for the real-time status
    const verifyResp = await verifyPaymentStatus(bookingNumber.value as string)
    
    if (verifyResp && verifyResp.data && verifyResp.data.payment_status === 'paid') {
      feedType.value = 'success'
      isLoading.value = false
      message.value = 'Thank you for booking with Vehitra World! Your voucher and receipt will be sent to your email shortly.'
      await upsertDeal()
      clearSessionData()
      return true
    } else if (verifyResp && verifyResp.data && verifyResp.data.payment_status === 'failed') {
      // Only show error if we DON'T have a success hint from the URL
      if (!isSuccessHint) {
        feedType.value = 'error'
        isLoading.value = false
        hasError.value = true
        errorMessage.value = 'Payment Failed. The transaction was declined or your card is not supported.'
        return true
      }
    }

    // Fallback: check local database
    const currentBooking = await readBooking(bookingNumber.value as string)
    if (currentBooking.success && currentBooking.data?.data && (currentBooking.data.data.payment?.status === 'paid' || currentBooking.data.data.status === 'confirmed')) {
      feedType.value = 'success'
      isLoading.value = false
      message.value = 'Thank you for booking with Vehitra World! Your voucher and receipt will be sent to your email shortly.'
      await upsertDeal()
      clearSessionData()
      return true
    }
    
    return false // Keep polling
  }

  // Initial check
  if (await checkPaymentStatus()) return

  // Polling loop
  const pollInterval = setInterval(async () => {
    attempts++
    if (await checkPaymentStatus()) {
      clearInterval(pollInterval)
    } else if (attempts >= maxAttempts) {
      clearInterval(pollInterval)
      
      // 16 SECONDS PASSED - Show success message but keep the current (pending) voucher
      feedType.value = 'success'
      isLoading.value = false
      message.value = 'Thank you for booking with Vehitra World! Your voucher and receipt will be sent to your email shortly.'
      
      // We don't refresh the booking data here because we WANT it to show as "Request" 
      // until the bank actually confirms it later via webhook.
      clearSessionData()
    }
  }, 4000)

  const finishFinalCapture = async () => {
    if (paymentWallet === 'card' && transaction) {
      const response = await authorizePayment(session, booking, transaction, cvc as string)
      if (response.status === 200) {
        const res = response.data.response

        if (!res || !res.response || res.response.gatewayCode !== 'APPROVED' || !res.result || res.result !== 'SUCCESS') {
          feed.value = res
          feedType.value = 'error'
        } else {
          feed.value = res.order
          feedType.value = 'success'
        }

        const finalResponse = await finalizeeBooking(bookingNumber.value as string, feedType.value as any, feed.value, false)
        isLoading.value = false

        await upsertDeal()

        if (finalResponse.success) {
          message.value = 'A booking has been created and payment has been received'
          clearSessionData()
        } else {
          hasError.value = true
          errorMessage.value = 'We encountered an error while processing your payment'
        }
      } else {
        isLoading.value = false
        hasError.value = true
        errorMessage.value = handleApiError(response)
      }
    } else if (paymentWallet === 'apple_pay') {
      feedType.value = 'success'
      feed.value = 'apple_pay'
      const finalResponse = await finalizeeBooking(bookingNumber.value as string, feedType.value as any, feed.value, false)
      isLoading.value = false

      if (finalResponse.success) {
        message.value = 'A booking has been created and payment has been received'
        clearSessionData()
      } else {
        hasError.value = true
        errorMessage.value = 'We encountered an error while processing your payment'
      }
    } else {
      isLoading.value = false
      hasError.value = true
      errorMessage.value = 'Payment confirmation is pending. Please check your email or contact support.'
    }
  }
})

const upsertDeal = async () => {
  const bookingId = parseInt(bookingNumber.value as string)
  const deal      = parseInt(dealId.value as string)

  if (authUser && (authUser.user.type === 'agent' || authUser.user.type === 'corporate')) {
    await updateDeal(deal, bookingId)
  } else {
    await createContact(bookingId)
    await createDeal(bookingId)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute inset-0 bg-[#0f1418]/60 backdrop-blur-md" }, null, -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute h-full w-full animate-spin rounded-full border-4 border-white/10 border-t-emerald-500" }, null, -1)),
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-shield-halved",
                class: "text-3xl text-emerald-400/80"
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(isPaying.value ? 'Verifying Payment' : 'Processing Request'), 1),
              _createElementVNode("p", _hoisted_6, [
                _createTextVNode(_toDisplayString(isPaying.value ? 'We are securely communicating with your bank to confirm the transaction.' : 'We are finalizing your request. Please wait...') + " ", 1),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "block mt-1 font-semibold text-emerald-400/90" }, "Please do not refresh or close this page.", -1))
              ])
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "h-1.5 w-64 overflow-hidden rounded-full bg-white/10" }, [
              _createElementVNode("div", { class: "h-full animate-progress rounded-full bg-emerald-500 shadow-[0_0_15px_rgba(16,185,129,0.5)]" })
            ], -1))
          ])
        ]))
      : (hasError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-theme-gray-5 text-head-md-2 md:text-head-xl text-center flex flex-col gap-3 mb-3" }, [
              _createElementVNode("div", null, "Error")
            ], -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "lg",
                    icon: "fa-solid fa-times-circle",
                    class: "text-red-400"
                  }),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(errorMessage.value), 1),
                    _createElementVNode("div", {
                      onClick: handleGoBack,
                      class: "font-medium text-sm text-red-700 underline hover:text-red-600 cursor-pointer"
                    }, _toDisplayString(_unref(isAgencyOrCorporate) ? 'Go to dashboard' : 'Go to home'), 1)
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (feedType.value === 'success')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "text-theme-active text-4xl",
                        icon: "fa-solid fa-check"
                      })
                    ]),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "h-[120px] w-[120px] rounded-full bg-theme-gray-1" }, null, -1))
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-center text-theme-gray-5 text-4xl md:text-6xl font-semibold" }, " Thank You ", -1)),
                    (bookingNumber.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Booking #" + _toDisplayString(bookingNumber.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("p", _hoisted_21, _toDisplayString(message.value), 1),
                      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mt-2 text-sm md:text-base text-green-700/80" }, [
                        _createTextVNode(" A confirmation email (and account details if requested) has been sent to you. "),
                        _createElementVNode("span", { class: "font-bold" }, "If you don't see it in your inbox shortly, please check your spam folder.")
                      ], -1)),
                      _createElementVNode("button", {
                        onClick: handleGoBack,
                        class: "mt-5 inline-flex items-center justify-center rounded-full border border-green-700 px-6 py-2.5 text-base md:text-lg font-semibold text-green-800 hover:bg-white"
                      }, _toDisplayString(_unref(isAgencyOrCorporate) ? 'Go to dashboard' : 'Go to home'), 1)
                    ])
                  ]),
                  _createVNode(BookingVoucher, { bookingNumber: bookingNumber.value }, null, 8, ["bookingNumber"])
                ]))
              : (feedType.value === 'error')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_font_awesome_icon, {
                          size: "2xl",
                          icon: "fa-solid fa-check",
                          class: "text-theme-active"
                        })
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "bg-theme-gray-1 w-[100px] h-[100px] rounded-full" }, null, -1))
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-theme-gray-5 text-head-md-2 md:text-head-xl text-center flex flex-col gap-3" }, [
                      _createElementVNode("div", null, "Thank You")
                    ], -1)),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_font_awesome_icon, {
                              size: "lg",
                              icon: "fa-solid fa-circle-exclamation",
                              class: "text-yellow-400"
                            }),
                            _createElementVNode("div", _hoisted_29, [
                              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-sm font-medium text-yellow-700" }, " A booking has been created for you but we did not receive payment from your bank. You will be contacted by our representative for further assistance ", -1)),
                              _createElementVNode("div", {
                                onClick: handleGoBack,
                                class: "font-medium text-sm text-yellow-700 underline hover:text-yellow-600 cursor-pointer"
                              }, _toDisplayString(_unref(isAgencyOrCorporate) ? 'Go to dashboard' : 'Go to home'), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
          ])),
    _createVNode(Loader, { show: isLoading.value }, null, 8, ["show"])
  ], 64))
}
}

})